/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { HTMLInputTypeAttribute } from "react";
import { Input, LabelField } from "components";
import cx from "classnames";
import styles from "./InputCode.module.scss";

interface ICodeInputProps {
  refs: React.MutableRefObject<Input[]>;
  id: number;
  keyHandler: (
    e: React.FormEvent<HTMLInputElement> & React.KeyboardEvent<HTMLInputElement>
  ) => void;
  isError?: boolean;
  type?: HTMLInputTypeAttribute;
  autoComplete?: string;
  containerClassName?: string;
  placeholder?: string;
  disable?: boolean;
}

export const InputCode = ({
  refs,
  id,
  keyHandler,
  isError,
  type = "text",
  autoComplete = "off",
  containerClassName,
  placeholder,
  disable,
}: ICodeInputProps) => (
  <LabelField
    className={cx(styles.InputCode, containerClassName)}
    name={`input_${id}`}
  >
    <Input
      className={cx(styles.InputContainer, {
        [styles.InputContainerError]: isError,
      })}
      inputClassName={styles.Input}
      placeholder={placeholder}
      type={type}
      autoComplete={autoComplete}
      onKeyDown={keyHandler}
      ref={(el: Input) => (refs.current[id] = el)}
      maxLength={1}
      name={String(id)}
      disabled={disable}
    />
  </LabelField>
);
